// extracted by mini-css-extract-plugin
export default {"canvas":"o51VHabyrOJvWTkTQLs0"};